import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Политика конфиденциальности | Тюменский научный журнал</title>
        <meta
          name="description"
          content="Политика конфиденциальности Тюменского научного журнала: порядок обработки персональных данных и использования файлов cookie."
        />
      </Helmet>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Политика конфиденциальности и обработки персональных данных
        </Typography>

        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body1">
            Настоящая политика конфиденциальности определяет порядок обработки и защиты персональных данных
            пользователей сайта Тюменского научного журнала.
          </Typography>

          <Typography variant="h6">1. Обрабатываемые данные</Typography>
          <Typography variant="body1">
            Мы можем обрабатывать следующие категории персональных данных:
            адрес электронной почты, фамилия, имя, отчество, сведения об организации и должности, а также иные
            данные, которые пользователь указывает при регистрации, подаче статьи или обращении в редакцию.
          </Typography>

          <Typography variant="h6">2. Цели обработки</Typography>
          <Typography variant="body1">
            Персональные данные обрабатываются для регистрации пользователей, организации процесса рецензирования и
            публикации статей, обратной связи с авторами и читателями, а также для исполнения требований
            действующего законодательства.
          </Typography>

          <Typography variant="h6">3. Использование файлов cookie</Typography>
          <Typography variant="body1">
            На сайте используются файлы cookie для обеспечения корректной работы сервиса, сохранения настроек
            пользователя и сбора обезличенной статистики посещений. Продолжая использовать сайт, вы соглашаетесь
            на использование файлов cookie.
          </Typography>

          <Typography variant="h6">4. Передача данных третьим лицам</Typography>
          <Typography variant="body1">
            Персональные данные могут передаваться третьим лицам только в случаях, предусмотренных законодательством,
            либо при наличии согласия пользователя.
          </Typography>

          <Typography variant="h6">5. Права пользователя</Typography>
          <Typography variant="body1">
            Пользователь имеет право запрашивать сведения о своих персональных данных, требовать их уточнения,
            блокирования или удаления в порядке, установленном действующим законодательством.
          </Typography>

          <Typography variant="h6">6. Контакты</Typography>
          <Typography variant="body1">
            По вопросам, связанным с обработкой персональных данных, вы можете обращаться по адресу электронной почты
            tyumen-science@yandex.ru.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default PrivacyPolicy;

